import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const ListItem = styled.li`
  padding: 9px 0;
  width: 100%;
  text-align: center;
  background: ${props => props.theme.color.bgYellow};

  &:hover, &:active {
    background: ${props => props.theme.color.bgMedium};
  }
`

const SubListItem = styled.li`
  padding: 7px 0;
  width: 100%;
  text-align: center;
  font-size: 20px;
  background: #f3f3f3;
  text-transform: none;

  &:hover, &:active {
    background: ${props => props.theme.color.bgLight};
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #fff;
`

const StyledLinkNormal = styled.a`
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const StyledSubLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.color.textPrimary};
`

const StyledSubLinkNormal = styled.a`
  text-decoration: none;
  color: ${props => props.theme.color.textPrimary};
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

// Menu Item
const Item = ({ children, to, ...props }) => (
  <ListItem {...props}>
    {!to.includes("noleggia")
      ? <StyledLinkNormal href={to}>{children}</StyledLinkNormal>
      : <StyledLink to={to}>{children}</StyledLink>
    }
  </ListItem>
)

const SubItem = ({ children, to, ...props }) => (
  <SubListItem {...props}>
    {!to.includes("noleggia")
      ? <StyledSubLinkNormal href={to}>{children}</StyledSubLinkNormal>
      : <StyledSubLink to={to}>{children}</StyledSubLink>
    }
  </SubListItem>
)

class Submenu extends Component {
  state = {}

  toggleSubmenu (item) {
    this.setState({ [item]: !this.state[item] })
  }

  render () {
    const { items } = this.props
    return (
      <React.Fragment>
        {items.headers.map((item, index) => (
          <React.Fragment>
            <Item
              key={item.name}
              to={item.url}
              onClick={this.toggleSubmenu.bind(this, item.name.toLowerCase().replace(/\s/g, ''))}
            >
              {item.name} <i className='fas fa-chevron-down fa-xs' />
            </Item>
            {this.state[item.name.toLowerCase().replace(/\s/g, '')] && items.lists[index].map(subItem => (
              <SubItem key={subItem.name} to={subItem.url}>{subItem.name}</SubItem>
            ))}
          </React.Fragment>
        ))}
      </React.Fragment>
    )
  }
}

export default Submenu



// WEBPACK FOOTER //
// ./src/components/UI/Header/MobileSubmenu.js